import { hermes } from '@owner/icons'

export const VALID_ICONS = hermes.ALLOWED_ICONS
